var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.profile.self)?_c('profile-blocked'):_vm._e(),_c('photo-swiper-small',{key:`small-${_vm.profile.id}`}),(!_vm.profile.self)?_c('profile-status'):_vm._e(),(!_vm.profile.self)?_c('profile-actions'):_vm._e(),(
            _vm.brand.enableCreatorSubscription &&
            _vm.canSubscribeToStandardMap(_vm.profile)
        )?_c('profile-subscribe'):_vm._e(),(!_vm.profile.self)?_c('profile-reputation'):_vm._e(),_c('profile-private-photos'),_c('profile-stats'),(!_vm.profile.self)?_c('profile-block-report'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }